import { render } from "./QToken.vue?vue&type=template&id=0aaae142"
import script from "./QToken.vue?vue&type=script&lang=js"
export * from "./QToken.vue?vue&type=script&lang=js"

import "./QToken.vue?vue&type=style&index=0&id=0aaae142&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__